import { isServerRendering } from './IsServerRendering';

export const isMobile = (): boolean => {
    return !isServerRendering() && window.innerWidth < 768;
};
